import React from 'react';
import { Box, Button, alpha, useTheme } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

interface BooleanFieldProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  disabled?: boolean;
}

const BooleanField: React.FC<BooleanFieldProps> = ({ value, onChange, disabled }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
      <Button
        variant={value === true ? 'contained' : 'outlined'}
        onClick={() => onChange(value === true ? null : true)}
        disabled={disabled}
        startIcon={<CheckIcon />}
        sx={{
          px: 4,
          py: 1.5,
          borderRadius: 2,
          textTransform: 'none',
          fontSize: '1rem',
          fontWeight: 500,
          minWidth: 120,
          borderColor: value === true ? 'primary.main' : alpha(theme.palette.divider, 0.5),
          '&:hover': {
            borderColor: 'primary.main',
          },
        }}
      >
        Yes
      </Button>
      <Button
        variant={value === false ? 'contained' : 'outlined'}
        onClick={() => onChange(value === false ? null : false)}
        disabled={disabled}
        startIcon={<CloseIcon />}
        sx={{
          px: 4,
          py: 1.5,
          borderRadius: 2,
          textTransform: 'none',
          fontSize: '1rem',
          fontWeight: 500,
          minWidth: 120,
          borderColor: value === false ? 'primary.main' : alpha(theme.palette.divider, 0.5),
          '&:hover': {
            borderColor: 'primary.main',
          },
        }}
      >
        No
      </Button>
    </Box>
  );
};

export default BooleanField;
